import { observer } from 'mobx-react'
import styles from './GoodsDetailModal.module.less'
import { DetailBox } from './GoodsDetail'
import { UserActionModuleEnum, UserActionElementEnum, UserActionEnum } from '@/helpers/commonConsts'
import { userService } from '@/services/userService'
import { useEffect } from 'react'
import { commonUtils } from '@/helpers/commonUtils'
import { GoodsDetailState } from './GoodsDetailState'
import { Skeleton } from 'antd'

const PreviewImg = observer(({ state }: { state: GoodsDetailState }) => {
  const { previewPath } = state.detail ?? {}
  const previews = previewPath?.split(',').filter(Boolean) ?? []
  if (state.loading) {
    return (
      <div className={styles.goodsPreviewImgs}>
        <Skeleton.Button
          className={styles.goodsPreviewItem}
          active
          block
          style={{ width: 650, height: 365 }}
        />
        <Skeleton.Button
          className={styles.goodsPreviewItem}
          active
          block
          style={{ width: 650, height: 365 }}
        />
      </div>
    )
  }

  return previews.length > 0
    ? previews.map((preview) => (
        <img
          className={styles.goodsPreviewItem}
          key={preview}
          src={commonUtils.getimageView(preview, 650, 365)}
          draggable={false}
          loading='lazy'
          style={{
            opacity: 0,
            transition: 'opacity 0.3s ease-in-out',
          }}
          alt={`预览图-${preview}`}
          onLoad={(e) => ((e.target as HTMLImageElement).style.opacity = '1')}
        />
      ))
    : null
})

const GoodsPreview = observer(({ state }: { state: GoodsDetailState }) => {
  useEffect(() => {
    userService.postUserActionRecord({
      module: UserActionModuleEnum.PC,
      function: '详情弹窗',
      position: '详情页点击预览',
      element: UserActionElementEnum.BUTTON,
      action: UserActionEnum.CLICK,
    })
  }, [])

  return (
    <div className={styles.goodsPreview}>
      <div className={styles.goodsPreviewImgs}>
        <PreviewImg state={state} />
      </div>
      <div className={styles.goodsDetailInfo}>
        <DetailBox state={state} />
      </div>
    </div>
  )
})

export default GoodsPreview
